import { render } from "./ArrowDown.vue?vue&type=template&id=6259ebac"
import script from "./ArrowDown.vue?vue&type=script&lang=js"
export * from "./ArrowDown.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/gift/data/www/giftxyz.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__